/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { useContext } from "react";
import { Flex } from "../Flex";
import { CardProps, CardWithSectionsContext, cardSizeToSx } from "./Card";

export type CardSectionProps = {
  size?: CardProps["size"];
  variant?: "none" | "light-contrast";
  direction?: CardProps["direction"];
  addLineSeperator?: boolean;
};
export const CardSection: ComponentWithChildren<CardSectionProps> = ({
  variant = "none",
  addLineSeperator = false,
  direction,
  size,
  children,
  sx,
  ...props
}) => {
  const { size: contextSize } = useContext(CardWithSectionsContext);
  const { direction: contextDirection = "horizontal" } = useContext(
    CardWithSectionsContext
  );

  const finalDirection = direction ?? contextDirection;

  return (
    <Flex
      {...props}
      sx={{
        width: "100%",
        flexDirection: finalDirection == "horizontal" ? "row" : "column",
        flexWrap: finalDirection == "horizontal" ? "wrap" : "nowrap",
        alignItems: "flex-start",
        ...cardSizeToSx(size ?? contextSize),
        ...(addLineSeperator && {
          borderStyle: "solid",
          borderWidth: "0 0 1px 0",
          borderColor: "var(--border-ultra-subtle)",
        }),
        ...(variant === "light-contrast" && { background: "var(--surface-secondary)" }),
        ...sx,
      }}
    >
      {children}
    </Flex>
  );
};
